<template>
    <div class="details-keeping-sector">
      <div class="d-flex justify-content-between">
        <h3 class="intern-title ml-3">
          <back-arrow />
          <span class="page-nav"
            >{{ $t("register") }}: {{ registro.fiscal_registro_id }}
            <span class="page-nav" v-if="!loadingData">
              {{ details.info.zeladoria_nome }}
            </span>
          </span>
        </h3>
      </div>
  
      <div class="activities-cards ml-3">
        
          <div class="activity-card pointer">
            <div class="activiy-icon">
              <svg width="45" height="45" viewBox="0 0 45 45" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_7482_4750)">
                <path d="M25.5 18.306C26.9313 18.306 28.0917 17.1457 28.0917 15.7143C28.0917 14.283 26.9313 13.1227 25.5 13.1227C24.0687 13.1227 22.9083 14.283 22.9083 15.7143C22.9083 17.1457 24.0687 18.306 25.5 18.306Z" fill="#A47AA9"/>
                <path d="M21.2 25.9185C19.9538 25.8944 18.7196 26.1657 17.5985 26.7103C16.4774 27.2549 15.5013 28.0574 14.75 29.0519C13.7958 30.3727 14.4875 32.556 15.85 32.556H26.55C27.9125 32.556 28.6 30.3727 27.6625 29.0519C26.9085 28.0571 25.9301 27.2547 24.807 26.7102C23.6839 26.1657 22.4479 25.8944 21.2 25.9185V25.9185Z" fill="#BEDB74"/>
                <path d="M30.3291 26.481C30.3398 26.4456 30.3427 26.4083 30.3376 26.3716C30.3326 26.335 30.3198 26.2998 30.3 26.2685C29.2123 24.6255 27.559 23.4393 25.6541 22.9352L24.6041 22.6435L25.5333 22.0727C26.2908 21.608 26.9134 20.9532 27.3394 20.1732C27.7654 19.3933 27.9798 18.5155 27.9613 17.6271C27.9429 16.7386 27.6923 15.8704 27.2343 15.1088C26.7764 14.3473 26.1271 13.7188 25.351 13.2859C24.5749 12.853 23.699 12.6308 22.8104 12.6413C21.9218 12.6519 21.0515 12.8948 20.2859 13.3459C19.5202 13.7971 18.886 14.4408 18.4463 15.213C18.0065 15.9852 17.7765 16.8591 17.7791 17.7477C17.7843 18.6375 18.0215 19.5106 18.4672 20.2808C18.913 21.051 19.5518 21.6916 20.3208 22.1394L21.2833 22.706L20.2083 23.0102C18.125 23.5977 16.6833 24.6769 15.8583 26.2477C15.4083 27.0435 14.95 28.8644 16.4166 30.1394C17.1129 30.7028 17.9879 30.9984 18.8833 30.9727H27.25C27.2898 30.9776 27.3301 30.9739 27.3684 30.962C27.4067 30.9501 27.4421 30.9302 27.4721 30.9036C27.5021 30.877 27.5261 30.8443 27.5426 30.8078C27.5591 30.7712 27.5676 30.7316 27.5676 30.6915C27.5676 30.6514 27.5591 30.6117 27.5426 30.5751C27.5261 30.5386 27.5021 30.5059 27.4721 30.4793C27.4421 30.4527 27.4067 30.4328 27.3684 30.4209C27.3301 30.409 27.2898 30.4054 27.25 30.4102H18.9166C18.1591 30.4265 17.4205 30.1725 16.8333 29.6935C15.3875 28.4435 16.2833 26.706 16.3875 26.5144C17.0708 25.2227 18.3333 24.2352 20.0416 23.6602C20.9702 23.3458 21.9408 23.1731 22.9208 23.1477H23.0375C27.775 23.1477 29.775 26.3935 29.8541 26.531C29.8727 26.5634 29.8974 26.5917 29.927 26.6144C29.9565 26.6372 29.9903 26.6539 30.0263 26.6635C30.0623 26.6732 30.0998 26.6757 30.1368 26.6708C30.1737 26.666 30.2094 26.6539 30.2416 26.6352C30.2881 26.5957 30.3191 26.5411 30.3291 26.481ZM22.8791 22.281C21.9825 22.281 21.106 22.0152 20.3605 21.517C19.615 21.0189 19.034 20.3109 18.6909 19.4825C18.3478 18.6542 18.258 17.7427 18.4329 16.8633C18.6078 15.9839 19.0396 15.1762 19.6736 14.5422C20.3076 13.9082 21.1153 13.4764 21.9947 13.3015C22.8741 13.1266 23.7856 13.2163 24.614 13.5595C25.4423 13.9026 26.1503 14.4836 26.6485 15.2291C27.1466 15.9746 27.4125 16.8511 27.4125 17.7477C27.4114 18.9497 26.9334 20.1021 26.0835 20.952C25.2335 21.802 24.0811 22.2799 22.8791 22.281V22.281Z" fill="black"/>
                <path d="M30.3791 20.8394C31.4499 18.1685 30.8916 16.4227 30.8708 16.3477C30.8504 16.2936 30.8139 16.247 30.7662 16.2142C30.7185 16.1814 30.662 16.1641 30.6041 16.1644H30.5833H30.5291C30.4591 16.1899 30.4016 16.2413 30.3683 16.3079C30.3349 16.3745 30.3284 16.4514 30.3499 16.5227C30.3999 16.6977 30.8083 18.2685 29.8666 20.6144C29.8522 20.6487 29.8447 20.6855 29.8447 20.7227C29.8447 20.7599 29.8522 20.7967 29.8666 20.831C29.8807 20.8652 29.9016 20.8962 29.9282 20.922C29.9547 20.9478 29.9862 20.9679 30.0208 20.981V20.981C30.0536 20.9955 30.0891 21.003 30.1249 21.003C30.1608 21.003 30.1963 20.9955 30.2291 20.981C30.2954 20.9547 30.349 20.904 30.3791 20.8394V20.8394Z" fill="black"/>
                </g>
                <rect x="1.16663" y="1.05603" width="43" height="43" rx="21.5" stroke="#C6C9D0"/>
                <defs>
                <clipPath id="clip0_7482_4750">
                <rect width="20" height="20" fill="white" transform="translate(12.6666 12.556)"/>
                </clipPath>
                </defs>
              </svg>
            </div>
            <div class="activity-counter">
              <div class="card-title">Fiscal</div>
              <div class="card-counter">
                {{registro.usuario_nome}}
              </div>
            </div>
          </div>

          <div class="activity-card pointer">
            <div class="activiy-icon">
              <svg width="45" height="45" viewBox="0 0 45 45" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M24.9833 28.7852H20.5624C19.7248 28.7852 19.0458 29.4643 19.0458 30.3019C19.0458 31.1395 19.7248 31.8186 20.5624 31.8186H24.9833C25.8209 31.8186 26.4999 31.1395 26.4999 30.3019C26.4999 29.4643 25.8209 28.7852 24.9833 28.7852Z" fill="#BEDB74"/>
                <path d="M23.9999 22.1185C25.8823 22.1185 27.4082 20.5926 27.4082 18.7102C27.4082 16.8278 25.8823 15.3019 23.9999 15.3019C22.1175 15.3019 20.5916 16.8278 20.5916 18.7102C20.5916 20.5926 22.1175 22.1185 23.9999 22.1185Z" fill="#A47AA9"/>
                <path d="M29.7 19.3102C29.5619 18.3461 29.2295 17.42 28.7229 16.5881C28.2164 15.7562 27.5462 15.0358 26.7531 14.4705C25.9599 13.9052 25.0602 13.5069 24.1086 13.2996C23.1569 13.0922 22.1731 13.0803 21.2166 13.2644C20.0468 13.4808 18.9499 13.987 18.0262 14.7367C17.1025 15.4864 16.3815 16.4557 15.9291 17.556C15.4631 18.6481 15.278 19.8396 15.3908 21.0216C15.5036 22.2036 15.9107 23.3385 16.575 24.3227C17.4469 25.5917 18.4091 26.7962 19.4541 27.9269C19.825 28.3435 20.2041 28.7269 20.6041 29.1394C20.7791 29.3283 20.9583 29.5158 21.1416 29.7019L21.175 29.7394H18.4666C18.401 29.7425 18.3391 29.7706 18.2934 29.8178C18.2477 29.865 18.2218 29.9279 18.2208 29.9935C18.2185 30.0625 18.2435 30.1295 18.2903 30.1802C18.3371 30.2309 18.4019 30.2611 18.4708 30.2644H26.6708C26.7368 30.258 26.7976 30.2261 26.8405 30.1755C26.8833 30.125 26.9046 30.0596 26.9 29.9935C26.9012 29.9304 26.8781 29.8692 26.8354 29.8227C26.7927 29.7761 26.7338 29.7478 26.6708 29.7435C26.6251 29.7393 26.579 29.7393 26.5333 29.7435H25.4791C24.5264 29.7435 23.575 29.7435 22.625 29.7435C22.416 29.7456 22.2088 29.7057 22.0156 29.6262C21.8224 29.5468 21.647 29.4294 21.5 29.281C19.8941 27.7308 18.4325 26.0377 17.1333 24.2227C16.5926 23.4893 16.2132 22.6498 16.02 21.7593C15.8268 20.8688 15.8242 19.9476 16.0125 19.056C16.2814 17.5917 17.0327 16.2594 18.1468 15.2717C19.2608 14.284 20.6735 13.6976 22.1595 13.606C23.6456 13.5145 25.1195 13.923 26.3464 14.7665C27.5733 15.61 28.4825 16.8399 28.9291 18.2602C29.2719 19.2631 29.3661 20.3342 29.2035 21.3815C29.0409 22.4288 28.6265 23.4209 27.9958 24.2727C26.9404 25.7408 25.7834 27.1331 24.5333 28.4394L24.5041 28.4685C24.4596 28.5108 24.4204 28.5584 24.3875 28.6102C24.356 28.6596 24.3422 28.7182 24.3484 28.7764C24.3546 28.8347 24.3804 28.8891 24.4215 28.9307C24.4627 28.9724 24.5168 28.9988 24.575 29.0057C24.6331 29.0125 24.6919 28.9994 24.7416 28.9685C24.7881 28.9384 24.8302 28.9019 24.8666 28.8602C26.1648 27.5174 27.3598 26.0786 28.4416 24.556C28.989 23.8089 29.3821 22.9602 29.5981 22.0596C29.8142 21.159 29.8488 20.2243 29.7 19.3102Z" fill="black"/>
                <path d="M22.6333 24.6935H22.6541C22.8115 24.6913 22.9687 24.6802 23.1249 24.6602C23.9209 24.5598 24.6733 24.2403 25.2984 23.7375C25.9236 23.2346 26.3968 22.5681 26.6655 21.8122C26.9342 21.0563 26.9877 20.2406 26.8202 19.456C26.6527 18.6714 26.2706 17.9488 25.7166 17.3685C25.3086 16.9379 24.8178 16.5941 24.2736 16.3578C23.7294 16.1215 23.1432 15.9976 22.5499 15.9935L22.3333 16.0144C22.1837 16.0207 22.0347 16.0374 21.8874 16.0644C21.1192 16.1694 20.3955 16.4868 19.7978 16.9807C19.2001 17.4746 18.7521 18.1255 18.5041 18.8602C18.2123 19.5713 18.1267 20.3503 18.2571 21.1079C18.3875 21.8654 18.7287 22.5709 19.2416 23.1435C19.2647 23.1755 19.2912 23.2049 19.3208 23.231C19.3671 23.2744 19.4282 23.2985 19.4916 23.2985C19.555 23.2985 19.6161 23.2744 19.6624 23.231C19.7129 23.1943 19.7469 23.1392 19.757 23.0776C19.7672 23.016 19.7526 22.9528 19.7166 22.9019C19.6866 22.855 19.6532 22.8104 19.6166 22.7685L19.5791 22.7227C19.076 22.107 18.7839 21.346 18.7458 20.5519C18.7092 19.867 18.8578 19.185 19.176 18.5775C19.4942 17.97 19.9702 17.4595 20.554 17.0995C21.1377 16.7396 21.8077 16.5436 22.4934 16.5322C23.1791 16.5208 23.8552 16.6943 24.4506 17.0346C25.046 17.3748 25.5388 17.8692 25.8771 18.4658C26.2153 19.0623 26.3866 19.739 26.3729 20.4247C26.3592 21.1103 26.161 21.7796 25.7991 22.3622C25.4373 22.9447 24.9252 23.419 24.3166 23.7352C23.8008 24.0012 23.2302 24.1438 22.6499 24.1519C22.4374 24.1519 22.3166 24.2519 22.3166 24.4185C22.3144 24.4514 22.3193 24.4844 22.3307 24.5153C22.3422 24.5461 22.3601 24.5742 22.3833 24.5977C22.4508 24.6611 22.5406 24.6955 22.6333 24.6935Z" fill="black"/>
                <path d="M20.0874 23.806C20.4364 24.1589 20.8762 24.4083 21.3582 24.5268C21.4289 24.5404 21.502 24.5258 21.562 24.4861C21.622 24.4463 21.664 24.3847 21.679 24.3143C21.6927 24.2432 21.6782 24.1695 21.6386 24.1088C21.5989 24.0482 21.5372 24.0053 21.4665 23.9893C21.0955 23.8979 20.7568 23.7062 20.4874 23.4352C20.4621 23.4073 20.4312 23.3851 20.3967 23.37C20.3623 23.3549 20.325 23.3473 20.2874 23.3477C20.2534 23.3475 20.2197 23.354 20.1882 23.3669C20.1568 23.3798 20.1282 23.3987 20.104 23.4227C20.0777 23.4467 20.0564 23.4757 20.0413 23.508C20.0262 23.5403 20.0177 23.5753 20.0161 23.6109C20.0146 23.6465 20.0201 23.6821 20.0323 23.7155C20.0445 23.749 20.0632 23.7798 20.0874 23.806Z" fill="black"/>
                <rect x="0.833252" y="1.05603" width="43" height="43" rx="21.5" stroke="#C6C9D0"/>
              </svg>
            </div>
            <div class="activity-counter">
              <div class="card-title">Área de zeladoria</div>
              <div class="card-counter">
                {{ registro.zeladoria_nome ? registro.zeladoria_nome : "--" }}
              </div>
            </div>
          </div>

          <div class="activity-card pointer">
            <div class="activiy-icon">
              <svg width="45" height="45" viewBox="0 0 45 45" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M24.9833 28.7852H20.5624C19.7248 28.7852 19.0458 29.4643 19.0458 30.3019C19.0458 31.1395 19.7248 31.8186 20.5624 31.8186H24.9833C25.8209 31.8186 26.4999 31.1395 26.4999 30.3019C26.4999 29.4643 25.8209 28.7852 24.9833 28.7852Z" fill="#BEDB74"/>
                <path d="M23.9999 22.1185C25.8823 22.1185 27.4082 20.5926 27.4082 18.7102C27.4082 16.8278 25.8823 15.3019 23.9999 15.3019C22.1175 15.3019 20.5916 16.8278 20.5916 18.7102C20.5916 20.5926 22.1175 22.1185 23.9999 22.1185Z" fill="#A47AA9"/>
                <path d="M29.7 19.3102C29.5619 18.3461 29.2295 17.42 28.7229 16.5881C28.2164 15.7562 27.5462 15.0358 26.7531 14.4705C25.9599 13.9052 25.0602 13.5069 24.1086 13.2996C23.1569 13.0922 22.1731 13.0803 21.2166 13.2644C20.0468 13.4808 18.9499 13.987 18.0262 14.7367C17.1025 15.4864 16.3815 16.4557 15.9291 17.556C15.4631 18.6481 15.278 19.8396 15.3908 21.0216C15.5036 22.2036 15.9107 23.3385 16.575 24.3227C17.4469 25.5917 18.4091 26.7962 19.4541 27.9269C19.825 28.3435 20.2041 28.7269 20.6041 29.1394C20.7791 29.3283 20.9583 29.5158 21.1416 29.7019L21.175 29.7394H18.4666C18.401 29.7425 18.3391 29.7706 18.2934 29.8178C18.2477 29.865 18.2218 29.9279 18.2208 29.9935C18.2185 30.0625 18.2435 30.1295 18.2903 30.1802C18.3371 30.2309 18.4019 30.2611 18.4708 30.2644H26.6708C26.7368 30.258 26.7976 30.2261 26.8405 30.1755C26.8833 30.125 26.9046 30.0596 26.9 29.9935C26.9012 29.9304 26.8781 29.8692 26.8354 29.8227C26.7927 29.7761 26.7338 29.7478 26.6708 29.7435C26.6251 29.7393 26.579 29.7393 26.5333 29.7435H25.4791C24.5264 29.7435 23.575 29.7435 22.625 29.7435C22.416 29.7456 22.2088 29.7057 22.0156 29.6262C21.8224 29.5468 21.647 29.4294 21.5 29.281C19.8941 27.7308 18.4325 26.0377 17.1333 24.2227C16.5926 23.4893 16.2132 22.6498 16.02 21.7593C15.8268 20.8688 15.8242 19.9476 16.0125 19.056C16.2814 17.5917 17.0327 16.2594 18.1468 15.2717C19.2608 14.284 20.6735 13.6976 22.1595 13.606C23.6456 13.5145 25.1195 13.923 26.3464 14.7665C27.5733 15.61 28.4825 16.8399 28.9291 18.2602C29.2719 19.2631 29.3661 20.3342 29.2035 21.3815C29.0409 22.4288 28.6265 23.4209 27.9958 24.2727C26.9404 25.7408 25.7834 27.1331 24.5333 28.4394L24.5041 28.4685C24.4596 28.5108 24.4204 28.5584 24.3875 28.6102C24.356 28.6596 24.3422 28.7182 24.3484 28.7764C24.3546 28.8347 24.3804 28.8891 24.4215 28.9307C24.4627 28.9724 24.5168 28.9988 24.575 29.0057C24.6331 29.0125 24.6919 28.9994 24.7416 28.9685C24.7881 28.9384 24.8302 28.9019 24.8666 28.8602C26.1648 27.5174 27.3598 26.0786 28.4416 24.556C28.989 23.8089 29.3821 22.9602 29.5981 22.0596C29.8142 21.159 29.8488 20.2243 29.7 19.3102Z" fill="black"/>
                <path d="M22.6333 24.6935H22.6541C22.8115 24.6913 22.9687 24.6802 23.1249 24.6602C23.9209 24.5598 24.6733 24.2403 25.2984 23.7375C25.9236 23.2346 26.3968 22.5681 26.6655 21.8122C26.9342 21.0563 26.9877 20.2406 26.8202 19.456C26.6527 18.6714 26.2706 17.9488 25.7166 17.3685C25.3086 16.9379 24.8178 16.5941 24.2736 16.3578C23.7294 16.1215 23.1432 15.9976 22.5499 15.9935L22.3333 16.0144C22.1837 16.0207 22.0347 16.0374 21.8874 16.0644C21.1192 16.1694 20.3955 16.4868 19.7978 16.9807C19.2001 17.4746 18.7521 18.1255 18.5041 18.8602C18.2123 19.5713 18.1267 20.3503 18.2571 21.1079C18.3875 21.8654 18.7287 22.5709 19.2416 23.1435C19.2647 23.1755 19.2912 23.2049 19.3208 23.231C19.3671 23.2744 19.4282 23.2985 19.4916 23.2985C19.555 23.2985 19.6161 23.2744 19.6624 23.231C19.7129 23.1943 19.7469 23.1392 19.757 23.0776C19.7672 23.016 19.7526 22.9528 19.7166 22.9019C19.6866 22.855 19.6532 22.8104 19.6166 22.7685L19.5791 22.7227C19.076 22.107 18.7839 21.346 18.7458 20.5519C18.7092 19.867 18.8578 19.185 19.176 18.5775C19.4942 17.97 19.9702 17.4595 20.554 17.0995C21.1377 16.7396 21.8077 16.5436 22.4934 16.5322C23.1791 16.5208 23.8552 16.6943 24.4506 17.0346C25.046 17.3748 25.5388 17.8692 25.8771 18.4658C26.2153 19.0623 26.3866 19.739 26.3729 20.4247C26.3592 21.1103 26.161 21.7796 25.7991 22.3622C25.4373 22.9447 24.9252 23.419 24.3166 23.7352C23.8008 24.0012 23.2302 24.1438 22.6499 24.1519C22.4374 24.1519 22.3166 24.2519 22.3166 24.4185C22.3144 24.4514 22.3193 24.4844 22.3307 24.5153C22.3422 24.5461 22.3601 24.5742 22.3833 24.5977C22.4508 24.6611 22.5406 24.6955 22.6333 24.6935Z" fill="black"/>
                <path d="M20.0874 23.806C20.4364 24.1589 20.8762 24.4083 21.3582 24.5268C21.4289 24.5404 21.502 24.5258 21.562 24.4861C21.622 24.4463 21.664 24.3847 21.679 24.3143C21.6927 24.2432 21.6782 24.1695 21.6386 24.1088C21.5989 24.0482 21.5372 24.0053 21.4665 23.9893C21.0955 23.8979 20.7568 23.7062 20.4874 23.4352C20.4621 23.4073 20.4312 23.3851 20.3967 23.37C20.3623 23.3549 20.325 23.3473 20.2874 23.3477C20.2534 23.3475 20.2197 23.354 20.1882 23.3669C20.1568 23.3798 20.1282 23.3987 20.104 23.4227C20.0777 23.4467 20.0564 23.4757 20.0413 23.508C20.0262 23.5403 20.0177 23.5753 20.0161 23.6109C20.0146 23.6465 20.0201 23.6821 20.0323 23.7155C20.0445 23.749 20.0632 23.7798 20.0874 23.806Z" fill="black"/>
                <rect x="0.833252" y="1.05603" width="43" height="43" rx="21.5" stroke="#C6C9D0"/>
              </svg>
            </div>
            <div class="activity-counter">
              <div class="card-title">Bairro</div>
              <div class="card-counter">
                {{ registro.bairro_nome ? registro.bairro_nome : "--" }}
              </div>
            </div>
          </div>

          <div class="activity-card pointer">
            <div class="activiy-icon">
              <svg width="45" height="45" viewBox="0 0 45 45" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_7482_4795)">
                <path d="M26.8242 27.9394V31.1977C26.8242 31.5019 27.1909 31.6519 27.4034 31.4394L30.8576 27.9852C31.1617 27.681 30.9534 27.1602 30.5201 27.1519L27.6867 27.0935C27.2117 27.0852 26.8201 27.4685 26.8201 27.9435L26.8242 27.9394Z" fill="#A47AA9"/>
                <path d="M23.5242 14.1644H15.0075C14.1492 14.1644 13.4534 14.8602 13.4534 15.7185C13.4534 16.5769 14.1492 17.2727 15.0075 17.2727H23.5242C24.3825 17.2727 25.0784 16.5769 25.0784 15.7185C25.0784 14.8602 24.3825 14.1644 23.5242 14.1644Z" fill="#BEDB74"/>
                <path d="M29.4117 13.4727L29.4033 13.4519L29.4117 13.4727Z" fill="black"/>
                <path d="M29.2117 13.1477L29.1951 13.1269C29.1951 13.1269 29.2076 13.1394 29.2117 13.1477Z" fill="black"/>
                <path d="M26.8117 13.2435L26.8033 13.256L26.8117 13.2435Z" fill="black"/>
                <path d="M26.9034 24.6019L26.8909 24.5935C26.0534 24.0227 25.2159 23.4477 24.3784 22.8769L22.8409 21.8269C22.2909 21.4519 21.745 21.0769 21.195 20.7019C21.07 20.6144 20.8784 20.506 20.6367 20.5477C20.27 20.6102 20.0409 20.8852 20.0367 21.2602C20.0367 21.4144 20.0367 21.5685 20.0367 21.7227C20.0367 21.956 20.0367 22.1935 20.0325 22.431C20.0284 22.6269 20.095 22.756 20.2575 22.8685C20.8117 23.2435 21.3742 23.6269 21.9159 23.9977L22.795 24.5977C22.995 24.7352 23.195 24.8727 23.395 25.0102C23.4659 25.0602 23.5075 25.1269 23.5075 25.1935C23.5075 25.2644 23.47 25.331 23.395 25.3852C23.3659 25.406 23.3367 25.4269 23.3075 25.4477L22.995 25.6602C22.4575 26.0269 21.9242 26.3894 21.3867 26.7602L21.3284 26.8019C21.2617 26.8477 21.2242 26.9227 21.2242 27.0019C21.2242 27.1352 21.3325 27.2435 21.4659 27.2435C21.5117 27.2435 21.5534 27.231 21.5867 27.2102C21.595 27.206 21.6075 27.1977 21.62 27.1894L22.3325 26.706C22.77 26.4102 23.22 26.1019 23.67 25.7894C23.8742 25.6477 23.995 25.431 23.995 25.2019C23.995 24.9685 23.8742 24.7477 23.6659 24.6019C23.4742 24.4685 23.2825 24.3394 23.0909 24.206L22.3825 23.7227C21.7742 23.306 21.1659 22.8894 20.5575 22.4727C20.5409 22.4602 20.5284 22.4477 20.5242 22.4394C20.52 22.081 20.5159 21.656 20.5242 21.2352C20.5242 21.1685 20.5534 21.1102 20.6034 21.0727C20.6492 21.0352 20.7034 21.0227 20.7575 21.031C20.7992 21.0394 20.8492 21.0602 20.9034 21.0977C22.3575 22.0894 23.8159 23.0852 25.27 24.0769L25.77 24.4185C26.0492 24.6102 26.3325 24.8019 26.6117 24.9935C26.695 25.0519 26.7409 25.1185 26.7409 25.1894C26.7409 25.2602 26.695 25.3352 26.6117 25.3935L21.5367 28.8602L21.4784 28.9019C21.2867 29.0352 21.0909 29.1644 20.8992 29.2977C20.7992 29.3644 20.7242 29.3769 20.645 29.3352C20.5575 29.2935 20.5242 29.2185 20.5242 29.1019V24.3227C20.5242 24.1894 20.4117 24.0769 20.2784 24.0769C20.145 24.0769 20.0325 24.1852 20.0325 24.3227V28.8644C20.0325 28.9727 20.0325 29.0852 20.0367 29.1977C20.0575 29.506 20.2742 29.7602 20.5825 29.831C20.6325 29.8435 20.6825 29.8477 20.7325 29.8477C20.9325 29.8477 21.095 29.756 21.195 29.6852C21.8117 29.2644 22.4284 28.8435 23.045 28.4227L25.345 26.8519C25.8575 26.5019 26.3659 26.1519 26.8784 25.806C27.0367 25.6977 27.1367 25.5727 27.1909 25.4227C27.295 25.1144 27.1825 24.8019 26.9075 24.606L26.9034 24.6019Z" fill="black"/>
                <path d="M32.4533 15.4143C32.4533 15.0102 32.1283 14.681 31.7325 14.681H29.5825C29.5575 14.6727 29.5325 14.6643 29.5075 14.6393C29.4742 14.606 29.4575 14.5643 29.4575 14.5143V14.3893C29.4575 14.2727 29.4617 14.1602 29.4575 14.056C29.42 13.4977 29.1617 13.0893 28.6908 12.8435C28.2158 12.5977 27.745 12.6227 27.2867 12.9185C26.9158 13.1602 26.7075 13.5227 26.6658 14.006V14.5977C26.6658 14.631 26.6408 14.6602 26.6033 14.6685C26.0325 14.6685 25.5867 14.6727 25.27 14.6727C23.8117 14.6727 23.0617 14.6727 23.0408 14.6727C22.9117 14.6727 22.8033 14.7768 22.8033 14.9102V14.9268C22.8033 15.056 22.9075 15.1602 23.0408 15.1602C23.0617 15.1602 23.8158 15.1602 25.2825 15.1602C25.7492 15.1602 26.1658 15.1602 26.4075 15.1602H26.5783C26.62 15.1602 26.6492 15.1977 26.6492 15.2352V15.8268C26.6492 15.8268 26.6492 15.8393 26.6492 15.8518C26.6575 16.1768 26.795 16.4727 27.0575 16.7352C27.3158 17.006 27.6492 17.156 27.995 17.156H28.0283C28.1242 17.156 28.2075 17.1185 28.2533 17.056C28.2908 17.006 28.2992 16.9393 28.2825 16.8685C28.2533 16.7685 28.1992 16.706 28.0158 16.6852C27.8033 16.6602 27.6117 16.5852 27.4617 16.4685C27.4283 16.4435 27.3992 16.4185 27.37 16.3893C27.345 16.3602 27.3242 16.3393 27.3033 16.3143C27.295 16.306 27.2867 16.2935 27.2783 16.281C27.1908 16.1518 27.145 16.0102 27.1408 15.8518C27.1242 15.2685 27.1242 14.6643 27.1408 14.0102C27.1533 13.5935 27.4783 13.2477 27.9158 13.1852C28.1992 13.1435 28.4492 13.2143 28.645 13.3768C28.8575 13.556 28.9783 13.8393 28.9867 14.1727C28.9867 14.2227 28.9867 14.3268 28.9867 14.4893C28.9867 14.581 28.9158 14.6602 28.82 14.6768H28.4825C28.4158 14.6768 28.3575 14.706 28.3075 14.7602V14.7685L28.2908 14.781C28.2575 14.8227 28.2408 14.8685 28.2408 14.9185C28.2408 14.9518 28.2492 14.9852 28.2658 15.0227C28.3117 15.131 28.4575 15.1685 28.5658 15.1685C28.7742 15.1685 31.7075 15.1602 31.7408 15.1602C31.8742 15.1602 31.9825 15.2727 31.9825 15.4143V17.106C31.9825 17.2393 32.0908 17.3477 32.2242 17.3477C32.3575 17.3477 32.4658 17.2393 32.4658 17.106V15.4143H32.4533Z" fill="black"/>
                <path d="M32.5367 18.9519V18.7644C32.5367 18.7227 32.5367 18.6894 32.5367 18.6519C32.5201 18.4102 32.3617 18.3519 32.2659 18.3352C32.2159 18.3352 32.1617 18.331 32.1076 18.331H15.4159C15.2867 18.331 15.1784 18.4394 15.1784 18.5685C15.1784 18.6977 15.2867 18.806 15.4159 18.806H15.7409C20.7992 18.806 31.0117 18.806 31.9492 18.806C32.0117 18.806 32.0617 18.856 32.0617 18.9185V27.9727L32.0201 27.981C31.9909 27.981 29.2117 27.981 28.9534 27.981C28.4034 27.981 28.0326 28.3602 28.0242 28.9144C28.0242 29.2185 28.0242 29.5269 28.0242 29.8435C28.0242 30.131 28.1534 30.1685 28.2534 30.1685C28.3242 30.1685 28.3742 30.1519 28.4117 30.1185C28.4659 30.0685 28.4951 29.9685 28.4951 29.8352C28.4951 29.681 28.4951 29.3852 28.4951 29.1727V28.8769C28.4951 28.7602 28.5451 28.6477 28.6367 28.5685C28.6492 28.556 28.6576 28.5519 28.6659 28.5435C28.6742 28.5394 28.6826 28.5352 28.6909 28.5269L28.7117 28.5144C28.7534 28.4894 28.8034 28.4727 28.8576 28.4685C28.9909 28.4435 31.4701 28.456 31.4951 28.456H31.7242L31.5367 28.6435C30.0117 30.1685 28.9534 31.2269 28.3951 31.7935C28.2409 31.9519 28.0701 32.0185 27.8409 32.0185C26.1992 32.0185 23.3992 32.0185 20.6409 32.0185H20.3117C15.9076 32.0185 13.6617 32.0185 13.6201 32.0144C13.3826 31.9977 13.2409 31.8602 13.2159 31.6227C13.2159 31.5352 13.2159 20.256 13.2159 16.5477V15.9185C13.2159 15.5144 13.5451 15.1769 13.9534 15.1685H14.0159C14.6326 15.1685 15.7409 15.1685 15.7576 15.1685H15.8034L15.8117 15.2102C15.8117 15.2102 15.8117 15.631 15.8117 15.7227C15.8201 16.356 16.1201 16.8019 16.6951 17.0602C16.8701 17.1352 17.0867 17.1477 17.2617 17.1477C17.2826 17.1477 17.3076 17.1477 17.3284 17.1394C17.4367 17.1185 17.5117 17.031 17.5117 16.9269C17.5117 16.8102 17.4159 16.7102 17.2992 16.7102H17.2617C17.2201 16.6977 17.1867 16.6935 17.1576 16.6894C17.0992 16.681 17.0451 16.6727 16.9951 16.6602C16.5951 16.5602 16.3201 16.2435 16.3076 15.8685C16.2867 15.2352 16.2867 14.6477 16.3076 14.0769C16.3242 13.6227 16.6659 13.2435 17.0992 13.1852C17.5701 13.1269 17.9909 13.3977 18.0951 13.831C18.1284 13.9727 18.1326 14.3144 18.1326 14.456C18.1326 14.5685 18.0451 14.656 17.9326 14.6602H17.6617C17.5201 14.6602 17.4076 14.7769 17.4076 14.9185C17.4076 15.0269 17.4784 15.1269 17.5867 15.1602C17.6742 15.1727 19.3659 15.1769 20.9992 15.1769C21.1201 15.1769 21.2159 15.2727 21.2159 15.3935V15.556C21.2242 15.6144 21.2242 15.7019 21.2284 15.7935C21.2576 16.5352 21.8284 17.1352 22.5284 17.1644H22.5659C22.8492 17.1644 22.8576 17.0227 22.8617 16.9519C22.8701 16.8019 22.7909 16.7269 22.5784 16.6977C22.0242 16.6227 21.7159 16.2769 21.7076 15.731C21.6992 15.156 21.7034 14.606 21.7076 14.1477C21.7117 13.6894 21.9326 13.3644 22.3284 13.231C22.7326 13.0935 23.1117 13.2185 23.3992 13.581C23.5659 13.7894 23.6867 13.7352 23.7659 13.6769C23.8576 13.6102 23.9242 13.5144 23.7784 13.2977C23.5701 12.981 23.2284 12.7685 22.8409 12.7144C22.4409 12.6602 22.0326 12.7727 21.7284 13.0269C21.4034 13.2977 21.2367 13.656 21.2284 14.1227V14.4644C21.2284 14.5727 21.1409 14.6644 21.0284 14.6644H18.8284C18.7117 14.6644 18.6201 14.5727 18.6201 14.4602C18.6201 14.431 18.6201 14.0935 18.6201 14.0602C18.5701 13.3269 18.0159 12.7435 17.3284 12.706C17.2992 12.706 17.2701 12.706 17.2409 12.706C16.5117 12.706 15.9451 13.1894 15.8284 13.9102C15.8159 13.9727 15.8117 14.0352 15.8076 14.1019V14.706L13.9659 14.6894C13.2826 14.6769 12.7284 15.231 12.7284 15.9144V31.4644C12.7284 32.1394 13.0909 32.4977 13.7742 32.4977H18.7992C20.6451 32.4977 22.5159 32.4977 24.3867 32.4977C25.2701 32.4977 26.1534 32.4977 27.0326 32.4977C27.4367 32.4977 27.8326 32.4977 28.2242 32.4727C28.3201 32.4685 28.4076 32.4269 28.4742 32.3602C28.9284 31.9102 29.9409 30.8977 30.8367 30.0019L32.3742 28.4685C32.4909 28.3519 32.5409 28.2269 32.5409 28.0394C32.5409 26.1102 32.5409 21.5144 32.5409 18.9477L32.5367 18.9519Z" fill="black"/>
                </g>
                <rect x="1.17004" y="1.05603" width="43" height="43" rx="21.5" stroke="#C6C9D0"/>
                <defs>
                <clipPath id="clip0_7482_4795">
                <rect width="20" height="20" fill="white" transform="translate(12.67 12.556)"/>
                </clipPath>
                </defs>
              </svg>
            </div>
            <div class="activity-counter">
              <div class="card-title">Criação</div>
              <div class="card-counter">
                {{ formatDate(registro.fiscal_registro_data) }}
              </div>
            </div>
          </div>

          <div class="activity-card pointer">
            <div class="activiy-icon">
              <svg width="45" height="45" viewBox="0 0 45 45" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_7482_4770)">
                <path d="M24.3859 23.7102L22.9109 20.6852L21.4318 23.7102C21.3359 23.9185 21.2776 24.1477 21.2776 24.3893C21.2776 25.2893 22.0068 26.0185 22.9068 26.0185C23.8068 26.0185 24.5359 25.2893 24.5359 24.3893C24.5359 24.1477 24.4776 23.9185 24.3818 23.7102H24.3859Z" fill="#BEDB74"/>
                <path d="M27.2651 21.8435C29.6698 21.8435 31.6192 19.8941 31.6192 17.4894C31.6192 15.0846 29.6698 13.1352 27.2651 13.1352C24.8603 13.1352 22.9109 15.0846 22.9109 17.4894C22.9109 19.8941 24.8603 21.8435 27.2651 21.8435Z" fill="#A47AA9"/>
                <path d="M27.5443 27.4561C27.9526 26.8561 28.4776 25.8436 28.6526 24.4102V24.3769C28.6734 24.3061 28.6651 24.2352 28.6401 24.1769C28.5693 24.0227 28.3901 23.9519 28.2318 24.0186C28.0693 24.0894 28.0526 24.2311 28.0401 24.3352C27.8818 25.6269 27.2484 27.9436 24.7526 28.9186V28.9102C24.5068 29.0769 23.4318 29.3811 22.6234 29.3811H22.5526L22.5443 29.1352C22.5443 29.0352 22.5401 28.9311 22.5359 28.8394C22.5276 28.6394 22.4193 28.5186 22.2484 28.5186C22.0734 28.5186 21.9693 28.6352 21.9651 28.8394C21.9651 28.9477 21.9651 29.0519 21.9651 29.1602V29.3811H21.8901C18.6443 29.2477 16.3859 26.3602 16.3818 23.8519V23.7811H16.7609C17.1734 23.7811 17.2318 23.6269 17.2318 23.4977C17.2318 23.4186 17.2109 23.3602 17.1693 23.3186C17.0984 23.2477 16.9651 23.2061 16.7693 23.2061C16.6901 23.2061 16.6109 23.2019 16.5318 23.1977L16.3401 23.1894L16.3484 23.1144C16.3526 23.0602 16.3568 23.0102 16.3609 22.9602C16.3693 22.8561 16.3776 22.7644 16.3901 22.6727C16.7901 19.9227 18.9859 17.8352 21.7276 17.6061C24.9526 17.3352 27.2943 19.5602 27.9401 21.9019C27.9734 22.0311 28.0026 22.1644 28.0318 22.2936C28.0568 22.4019 28.0776 22.5102 28.1068 22.6186C28.1151 22.6477 28.1234 22.6769 28.1359 22.7019C28.1818 22.8061 28.2776 22.8727 28.3901 22.8727C28.5401 22.8727 28.6609 22.7519 28.6609 22.6019C28.6609 22.5936 28.6609 22.5852 28.6609 22.5769C28.6651 22.5186 28.6526 22.4602 28.6443 22.4061L28.6359 22.3602C28.1109 19.2686 25.2943 17.0019 22.2318 17.0019C21.8984 17.0019 21.5609 17.0269 21.2276 17.0852C19.2818 17.4061 17.6068 18.5686 16.6276 20.2811C15.6526 21.9811 15.4984 23.9977 16.1943 25.8144C17.1318 28.2561 19.4234 29.8894 22.0318 29.9769C22.0526 29.9769 22.0651 29.9769 22.0776 29.9769H22.2151C22.3443 29.9769 22.4734 29.9769 22.6068 29.9686C23.7318 29.9186 24.7276 29.6686 25.5651 29.2269C26.3651 28.8061 27.0318 28.2102 27.5484 27.4561H27.5443Z" fill="black"/>
                <path d="M31.0443 23.4894C31.0443 23.3269 31.0401 23.1644 31.0318 22.9977C31.0359 22.9477 31.0359 22.9102 31.0318 22.8727C30.9401 21.6686 30.6234 20.5352 30.0859 19.4977C29.7318 18.7977 29.2818 18.1519 28.7568 17.5686L28.7151 17.5227L29.2193 16.9269L29.2734 16.9811C29.3068 17.0144 29.3359 17.0436 29.3651 17.0686C29.4234 17.1269 29.4734 17.1769 29.5318 17.2227C29.6651 17.3352 29.8193 17.3352 29.9276 17.2227C30.0401 17.1061 30.0443 16.9436 29.9401 16.8311C29.6151 16.4936 29.2693 16.1436 28.9151 15.8019C28.7943 15.6852 28.6401 15.6852 28.5193 15.7977C28.4026 15.9102 28.4026 16.0727 28.5193 16.2102C28.5693 16.2727 28.6276 16.3269 28.6818 16.3811L28.7943 16.4936L28.2651 17.0644L28.2109 17.0144C27.0068 15.8977 25.5234 15.1436 23.9234 14.8269L23.8651 14.8144V14.7561C23.8651 14.6561 23.8651 14.5561 23.8651 14.4561C23.8651 14.2394 23.8651 14.0269 23.8651 13.8186C23.8484 13.2477 23.4068 12.8061 22.8401 12.7894C22.4901 12.7811 22.1151 12.7811 21.6276 12.7894C21.3443 12.7936 21.0984 12.9061 20.8943 13.1186C20.8068 13.2102 20.6859 13.3936 20.8609 13.5644C20.9734 13.6769 21.1234 13.6644 21.2984 13.5311C21.4401 13.4227 21.5609 13.3686 21.6734 13.3644C21.9901 13.3477 22.3151 13.3519 22.6276 13.3561H22.7984C23.0609 13.3602 23.2484 13.5061 23.2734 13.7227C23.2984 13.9394 23.2943 14.1602 23.2859 14.3727C23.2859 14.4602 23.2818 14.5519 23.2818 14.6394V14.7227L23.2026 14.7144C20.6401 14.4311 18.1234 15.2686 16.2484 16.9977L16.1984 17.0436L15.6276 16.4644L15.6901 16.4144C15.7193 16.3936 15.7484 16.3686 15.7776 16.3477C15.8359 16.3019 15.8943 16.2602 15.9401 16.2102C16.0651 16.0769 16.0693 15.9144 15.9568 15.7977C15.8359 15.6769 15.6776 15.6769 15.5484 15.7977C15.2109 16.1227 14.8693 16.4644 14.5401 16.8102C14.4276 16.9269 14.4234 17.0894 14.5318 17.2061C14.6484 17.3269 14.8068 17.3269 14.9443 17.2061C15.0068 17.1561 15.0609 17.1019 15.1193 17.0477L15.2443 16.9311L15.7859 17.4561L15.7359 17.5102C14.7984 18.5269 14.1068 19.7644 13.7318 21.0852C13.5526 21.6977 13.4484 22.3352 13.4151 22.9769C13.4068 23.1477 13.3984 23.3186 13.3984 23.4852C13.3984 25.1269 13.8568 26.7352 14.7234 28.1269C16.6443 31.2519 20.2443 32.8352 23.8984 32.1686C23.9776 32.1561 24.0443 32.1352 24.0984 32.1102C28.1318 31.2227 31.0443 27.6019 31.0443 23.4852V23.4894ZM22.2193 31.7436C18.4859 31.7436 15.2068 29.2269 14.2443 25.6186L14.2193 25.5269C13.9068 24.2769 13.8943 23.0227 14.1776 21.7852C14.3776 20.9019 14.6776 20.0894 15.0734 19.3644C15.8276 18.0602 16.9234 16.9852 18.2443 16.2602C18.9276 15.9102 19.6859 15.6394 20.5068 15.4644C21.2526 15.3019 21.9901 15.2311 22.6984 15.2519C24.1859 15.3394 25.6234 15.8269 26.8568 16.6644C27.5276 17.1436 28.1609 17.7477 28.7401 18.4561C28.8526 18.5936 28.9609 18.7394 29.0693 18.8894C29.9901 20.2519 30.4734 21.8436 30.4734 23.4894C30.4734 28.0394 26.7693 31.7436 22.2193 31.7436Z" fill="black"/>
                <path d="M22.1985 25.0644C21.8901 25.0644 21.586 24.9894 21.3235 24.8435C21.011 24.6685 20.7651 24.4185 20.5943 24.0894C20.5318 23.9685 20.5776 23.8144 20.6985 23.7519C20.8193 23.6894 20.9735 23.7352 21.036 23.856C21.161 24.0935 21.3401 24.281 21.5651 24.406C21.9318 24.6102 22.3985 24.6185 22.8151 24.431C23.686 24.0394 23.6943 23.0644 23.5026 22.6269C23.2568 22.0644 22.5901 20.6852 22.2568 19.9977L21.0443 22.5477C20.986 22.6727 20.836 22.7269 20.711 22.6644C20.586 22.606 20.5318 22.456 20.5943 22.331L22.0693 19.2352L22.2568 19.2144C22.3651 19.2144 22.4693 19.2769 22.5151 19.3769C22.561 19.4685 23.6276 21.656 23.9651 22.4227C24.2651 23.1102 24.1735 24.3685 23.0235 24.8852C22.761 25.0019 22.4818 25.0602 22.2068 25.0602L22.1985 25.0644Z" fill="black"/>
                </g>
                <rect x="0.840088" y="1.05603" width="43" height="43" rx="21.5" stroke="#C6C9D0"/>
                <defs>
                <clipPath id="clip0_7482_4770">
                <rect width="20" height="20" fill="white" transform="translate(12.3401 12.556)"/>
                </clipPath>
                </defs>
              </svg>
            </div>
            <div class="activity-counter">
              <div class="card-title">Status</div>
              <div class="card-counter">
                {{ registro.fiscal_registro_status }}
              </div>
            </div>
          </div>
      </div>

      <div class="description-box">
        <span class="page-nav">Descrição</span>
        <span class="description">{{ registro.fiscal_registro_descricao }}</span>
      </div>

      <div class="ml-3">
        <div class="map-container">
          <div class="map-title">
            <div>Registro dos últimos 15 dias na AZ</div>
            <button @click="monitorCancellationModal = true" class="timeline-button">Ver linha do tempo</button>
          </div>
          <div class="map-info">
            <CSelect
              class="select-atividade" 
              @change="changeActivity"
              :options="activityOptions"
              :value.sync="activityOption"
            >
            <!--<option :value="item" v-for="(item, id) of atividades" :key="id">
            {{ item.atividade_nome }}
          </option>-->
            </CSelect>
            <div class="map-subtitle">
              <svg width="16" height="19" viewBox="0 0 16 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8.19941 18.3477L2.88766 13.0422C1.83657 11.9911 1.12334 10.6522 0.835538 9.2007C0.54774 7.73668 0.691639 6.22887 1.26098 4.8587C1.83032 3.48853 2.79381 2.31232 4.02634 1.48646C5.26512 0.660609 6.71662 0.222656 8.19941 0.222656C9.68219 0.222656 11.1337 0.660609 12.3725 1.48646C13.605 2.31232 14.5685 3.48228 15.1378 4.8587C15.7072 6.22887 15.8573 7.74294 15.5633 9.19444C15.2755 10.6522 14.556 11.9911 13.5112 13.0359L8.19941 18.3477Z" fill="#00B1EB"/>
              </svg>
              <span class="subtitle-text">Fiscalização</span>
              <svg width="16" height="19" viewBox="0 0 16 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M14.9656 5.32066L14.9659 5.3214C15.4973 6.60024 15.6371 8.01296 15.363 9.366L15.3625 9.36844C15.0941 10.7282 14.4227 11.9779 13.4474 12.9532L8.48899 17.9116L3.53101 12.9595C2.55013 11.9786 1.88449 10.7291 1.61586 9.37468C1.34683 8.0057 1.48184 6.59849 2.0125 5.3214C2.54409 4.04209 3.44373 2.94388 4.59394 2.17303C5.75037 1.4022 7.10517 0.9935 8.4892 0.9935C9.87324 0.9935 11.228 1.40221 12.3845 2.17304C13.5353 2.94431 14.4344 4.03636 14.9656 5.32066Z" stroke="black"/>
              </svg>
              <span class="subtitle-text">Zelador</span>
            </div>
          </div>
          <div class="map-box">
            <GmapMap 
              ref="googleMap"
              :center="center"
              :zoom="zoom"
              class="map-az"
              :options="{
                zoomControl: false,
                mapTypeControl: false,
                scaleControl: false,
                streetViewControl: false,
                rotateControl: true,
                mapTypeId: mapType,
                gestureHandling: 'greedy',
                fullscreenControl: false,
                disableDefaultUi: true,
              }"
            >
              <div
                v-for="polygon of polygonKeepingSector"
                :key="'polygonsKeepingSector' + polygon.id"
              >
                <GmapPolygon
                  ref="polygon"
                  :paths="polygon.latlngs"
                  :options="polygon.options"
                />
              </div>

                <GmapCustomMarker
                  :zIndex="200"
                  class="markerGoogle-registro"
                  :clickable="true"
                  :draggable="false"
                  :marker="{
                      lat: registro.fiscal_registro_lat,
                      lng: registro.fiscal_registro_lng,
                    }"
                >
                  <div class="pinMarker">
                    <span class="pinCounter">
                      <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M15.5258 13.8475L19.095 17.4158L17.9158 18.595L14.3475 15.0258C13.0197 16.0902 11.3683 16.6691 9.66663 16.6667C5.52663 16.6667 2.16663 13.3067 2.16663 9.16666C2.16663 5.02666 5.52663 1.66666 9.66663 1.66666C13.8066 1.66666 17.1666 5.02666 17.1666 9.16666C17.169 10.8683 16.5901 12.5198 15.5258 13.8475ZM13.8541 13.2292C14.9117 12.1416 15.5023 10.6837 15.5 9.16666C15.5 5.94333 12.8891 3.33333 9.66663 3.33333C6.44329 3.33333 3.83329 5.94333 3.83329 9.16666C3.83329 12.3892 6.44329 15 9.66663 15C11.1837 15.0024 12.6415 14.4118 13.7291 13.3542L13.8541 13.2292ZM10.6483 5.98C10.4026 6.091 10.1874 6.25996 10.0214 6.47238C9.8553 6.6848 9.74325 6.93434 9.69483 7.19959C9.64641 7.46484 9.66306 7.73788 9.74337 7.99528C9.82367 8.25267 9.96523 8.48674 10.1559 8.6774C10.3465 8.86806 10.5806 9.00962 10.838 9.08992C11.0954 9.17023 11.3685 9.18688 11.6337 9.13846C11.899 9.09004 12.1485 8.97799 12.3609 8.81192C12.5733 8.64585 12.7423 8.43072 12.8533 8.185C13.0723 8.89635 13.0469 9.66054 12.7812 10.3558C12.5155 11.051 12.0247 11.6374 11.3871 12.0213C10.7495 12.4053 10.0017 12.5648 9.26289 12.4745C8.5241 12.3841 7.83679 12.0491 7.31049 11.5228C6.78419 10.9965 6.44918 10.3092 6.35883 9.5704C6.26848 8.8316 6.428 8.08382 6.81196 7.4462C7.19593 6.80858 7.78225 6.31782 8.4775 6.0521C9.17275 5.78638 9.93694 5.761 10.6483 5.98Z" fill="white"/>
                      </svg>
                    </span>
                  </div>
                </GmapCustomMarker>

                <GmapCustomMarker
                  v-for="pin, index of pins"
                  class="markerGoogle"
                  :clickable="true"
                  :key="pin.execucao_timeline_uuid + Math.random()"
                  :draggable="false"
                  @click.native="indexPins = index"
                  :marker="{
                      lat: pin.execucao_timeline_lat,
                      lng: pin.execucao_timeline_lng,
                    }"
                >
                  <div class="pinMarker">
                    <span class="pinCounter">{{ index + 1 }}</span>
                  </div>
                </GmapCustomMarker>

            </GmapMap>
            <div class="mapTypeControllers">
              <CSelect
                :placeholder="$t('type')"
                :options="mapTypes"
                :value.sync="mapType"
              ></CSelect>
            </div>
          </div>
        </div>

        <div class="page-nav title-galeria">Galeria da fiscalização</div>
        <div class="galeria-box">
          <div class="cards">
              <div v-for="(item, id) of photos" :key="item.fiscal_registro_foto_uuid">
                <div class="timeline-card">
                  <img
                    @click="index = id"
                    :src="item.fiscal_registro_foto"
                    class="galeriaClick"
                    alt=""
                  />
                  <div class="timeline-card-content">
                    <div class="content-tag">
                      {{ item.fiscal_tag_descricao }}
                    </div>
                    <div class="content-date">
                      {{ formatDate(item.fiscal_registro_foto_data) }}
                    </div>
                    <div class ="content-coord-title">Coordenadas:</div>
                    <div class="content-coord" @click="googleMapsSearch(item.fiscal_registro_foto_lat, item.fiscal_registro_foto_long)">
                      <span>{{ item.fiscal_registro_foto_lat }} , {{ item.fiscal_registro_foto_long }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
        </div>
        <CoolLightBox
          :items="computedPhotos"
          :index="index"
          @close="index = null"
        />
        <CoolLightBox
            :items="computedPhotosPins"
            :index="indexPins"
            @close="indexPins = null"
          />
            <MonitorCancellationModal
              :titulo="'Linha do Tempo'"
              :pins="modalPins"
              :timeline="modalExecucoes"
              :polygons="polygonKeepingSector"
              :dates="executionDates"
              :loadingData="loadingData"
              :avaliacao="false"
              @close="monitorCancellationModal = false"
              v-show="monitorCancellationModal"
            />
      </div>
    </div>
  </template>
  
  <script>
  import services from "../../services";
  import { formatForGoogleMaps } from "../../utils/geoMaps";
  import moment from "moment";
  import CoolLightBox from "vue-cool-lightbox";
  import { todayLess15Days } from "../../utils/date"
  import GmapCustomMarker from "vue2-gmap-custom-marker";
  import MonitorCancellationModal from "../../components/MonitorCancellationModal.vue";
  
  import BackArrow from "../../components/BackArrow.vue";

  export default {
    name: "DetailsKeepingSector",
    components: {
      BackArrow,
      CoolLightBox,
      GmapCustomMarker,
      MonitorCancellationModal,
    },
    data() {
      return {
        details: {
          info: {},
          zeladoria: {
            qtdAcao: 0,
            qtdPesquisa: 0,
            qtdChamado: 0,
            qtdColeta: 0,
          },
        },
        zoom: 17,
        center: {
          lat: 0,
          lng: 0,
        },
        computedPhotos: [],
        computedPhotosPins: [],
        monitorCancellationModal: false,
        index: null,
        indexPins: null,
        registro: [],
        photos: [],
        pinsData: [],
        pins: [],
        modalPins: [],
        execucoesUUID: [],
        modalExecucoes: [],
        executionDates: {
          start: null,
          end: null,
        },
        atividade: {
          atividade_nome: "Todas as atividades",
          atividade_id: 0
        },
        activities: [
          {
            atividade_nome: "bla",
            atividade_quantidade: 0,
          }
        ],
        clusterStyles: [
        {
          textColor: "white",
          url: require("../../assets/img/map-cluster.svg"),
          height: 60,
          width: 60,
          textSize: 20,
        },
      ],
        atividades: [],
        bounds: [],
        polygonKeepingSector: [],
        polygonBlocks: [],
        type: "",
        loadingData: true,
        mapTypes: [
          { label: this.$t("sattellite"), value: "satellite" },
          { label: this.$t("roadmap"), value: "roadmap" },
          { label: this.$t("hybrid"), value: "hybrid" },
        ],
        mapType: "hybrid",
        activityOptions: [],
        activityOption: "Todas as atividades",
        keepingSectorIncluded: true,
      };
    },
    mounted: async function () {
      await this.getAtividades();
      await this.getSupervisorExecutionDetails();
      await this.getSupervisorPins();
      await this.getSupervisorPhotos();
      await this.postExecutionTimelineAggregated();
      await this.defineDates();
      this.loadingData = false;
    },
    methods: {

      async googleMapsSearch(lat, lng){
        let link = "https://www.google.com/maps?q="
        let fullLink = link + lng + "," + lat 
        window.open(fullLink);
        console.log(fullLink)
      },

      async postExecutionTimelineAggregated(){
        if(this.registro.zeladoria_id){
          const { data, errors } = await services.executions.postExecutionTimelineAggregated({
              execucoes: this.execucoesUUID,
              tag_id: [],
            });
          if (!errors) {
              this.modalExecucoes = data
          }
        }
      },

      async defineDates(){
        this.executionDates.start = todayLess15Days().toISOString()
        this.executionDates.end = new Date().toISOString()
      },

      changeActivity(){
        this.pins = []
        this.pinsData.forEach((item) => {
          if(this.activityOption === item.atividade_id){
            this.pins = item.execucao
          }
        })
        this.modalPins = []
        let counter = 1
        this.pins.forEach((item) => {
              this.modalPins.push({
                id: item.execucao_timeline_uuid,
                center: {
                  lat: item.execucao_timeline_lat,
                  lng: item.execucao_timeline_lng,
                },
                number: counter++,
              });
        });
        this.computedPhotosPins = []
        this.pins.map((item) => {
          this.computedPhotosPins.push({
            src: item.execucao_timeline_foto,
            description: `${this.formatDate(item.execucao_data_criacao)}`,
            title: item.atividade_nome
          })
        })
      },

      async getAtividades() {
        let atv = []
      const { data, errors } = await services.serviceOrder.getAtividade();
      if (!errors) {
        atv = data
        this.atividades.push(this.atividade)
        atv.map((item) => {
          this.atividades.push(item);
        });
        this.atividades.map((item) => {
          this.activityOptions.push({
            label: item.atividade_nome,
            value: item.atividade_id
          })
        })
      }
    },
      async getSupervisorExecutionDetails() {
        const { data, errors } =
          await services.UsersSupervisors.getSupervisorDetails(this.$route.params.id);
        if (!errors) {
          this.registro = data
          this.center.lat = data.fiscal_registro_lat
          this.center.lng = data.fiscal_registro_lng
          //this.center.lat = data.zeladoria_limite[0].x
          //this.center.lng = data.zeladoria_limite[0].y
          if(this.registro.zeladoria_limite){
            this.mountKeepingSector(this.registro.zeladoria_limite)
          }
        }
      },

      async getSupervisorPins() {
        if(this.registro.zeladoria_id){
          const { data, errors } =
            await services.UsersSupervisors.getSupervisorPins({
              data_inicio:  todayLess15Days(),
              zeladoria_id: this.registro.zeladoria_id
            });
            if (!errors) {
              this.pinsData = data
              this.pins = data[0].execucao
              this.pins.map((exec) => {
                this.execucoesUUID.push(exec.execucao_uuid)
              })
            }
        this.computedPhotosPins = []
        this.pins.map((item) => {
          this.computedPhotosPins.push({
            src: item.execucao_timeline_foto,
            description: `${this.formatDate(item.execucao_data_criacao)}`,
            title: item.atividade_nome
          })
        })
        this.modalPins = []
        let counter = 1
        this.pins.forEach((item) => {
              this.modalPins.push({
                id: item.execucao_timeline_uuid,
                center: {
                  lat: item.execucao_timeline_lat,
                  lng: item.execucao_timeline_lng,
                },
                number: counter++,
              });
        });
      }
      },

      async getSupervisorPhotos() {
        const { data, errors } =
          await services.UsersSupervisors.getSupervisorPhotos(this.$route.params.id);
        if (!errors) {
          this.photos = data
          this.photos.map((item) => {
        this.computedPhotos.push({
            src: item.fiscal_registro_foto,
            description: ` ${this.formatDate(item.fiscal_registro_foto_data)}`,
            title: item.fiscal_tag_descricao,
          });
        });
       
        }
      },

      formatDate(date) {
        if (date) {
          let dia = moment(date).utc().format("DD/MM/YYYY")
          let hora = moment(date).utc().format('LT')
          const result = dia + " - " + hora
          return result;
        }
        return "-";
      },

      mountKeepingSector(poligono) {
        if (poligono !== "") {
          this.polygonKeepingSector = [];
          const coordinatesJSONParse = poligono;
          let bairro = {
            latlngs: formatForGoogleMaps(coordinatesJSONParse[0]),
            options: {
              strokeColor: "#348534",
              fillColor: "#348534",
            },
            id: 1,
          };
  
          bairro.latlngs.map((item) => {
            this.bounds.push(item);
          });
          this.polygonKeepingSector.push(bairro);
        }
        this.fitBoundsGoogle();
      },

      fitBoundsGoogle() {
        this.$refs.googleMap.$mapPromise.then(() => {
          const b = new window.google.maps.LatLngBounds();
          for (let i of this.bounds) {
            b.extend({
              lat: i.lat,
              lng: i.lng,
            });
          }
          this.$refs.googleMap.fitBounds(b);
        });
      },
    },
  };
  </script>
  
  <style lang="scss" scoped>
  .map-az{
    height: 750px;
    width: 100%;
  }
  .details-keeping-sector {
    .activities-cards {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      gap: 16px;
  
      .activity-card {
        min-width: 292px;
        min-height: 88px;
        border: 1px solid #dddee3;
        border-radius: 16px;
        padding: 16px;
        display: flex;
        align-items: center;
        flex-direction: row-reverse;
        justify-content: space-between;
  
        .card-counter {
          font-family: "OpenSans-Regular";
          font-size: 14px;
          line-height: 32px;
          color: #565E73;
          margin: 0;
          padding: 0;
        }
  
        .card-title {
          font-family: "Montserrat";
          font-weight: 500;
          font-size: 14px;
          line-height: 20px;
          letter-spacing: -0.014em;
          color: #131E3B;
          margin: 0;
          padding: 0;
        }
      }
    }
  
    .map-container {
      position: relative;
      border-radius: 16px;
      background-color: #fff;
      margin-top: 32px;
      padding: 48px;
      border: 1px solid #C6C9D0;
      border-radius: 32px;
  
      .map-title {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        font-family: "Montserrat";
        font-weight: 500;
        font-size: 20px;
        line-height: 32px;
        letter-spacing: -0.017em;
        color: #29334e;
        margin-bottom: 32px;
      }
    }
  
    .img-border {
      border-radius: 50%;
      border: 1px solid #dddee3;
      padding: 8px;
    }
  }
  
  .mapTypeControllers {
    position: absolute;
    top: 30px;
    left: 20px;
    z-index: 500;
    width: 120px;
  }
  
  .switch-label {
    font-family: "Montserrat";
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    color: #565e73;
  }

  .cards {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 24px;
    padding-top: 0;
    margin-bottom: 24px;

    .timeline-card {
      border-radius: 8px;
      box-shadow: 0px 4px 4px rgba(160, 168, 189, 0.24);
      border-radius: 8px;
      max-width: fit-content;
      height: 100%;
      margin: 10px 0;

      .timeline-card-content {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        padding: 24px 16px;
        height: 100%;
        font-size: 12px;
      }

      .galeriaClick {
        max-width: 286px;
        width: 286px;

        &:hover {
          cursor: pointer;
          opacity: 0.9;
        }

        border-radius: 8px 8px 0px 0px;
      }

      .content-tag {
        background: #dddee3;
        border-radius: 4px;
        padding: 2px 4px;
        margin-bottom: 12px;
        color: #565e73;
        font-family: "Montserrat";
        font-style: normal;
        font-weight: 600;
        font-size: 10px;
        line-height: 156%;
      }

      .content-date {
        font-family: "OpenSans-Regular";
        font-weight: 400;
        font-size: 12px;
        line-height: 20px;
        color: #838998;
      }
      .content-coord-title{
        font-family: "OpenSans-Regular";
        font-weight: 400;
        font-size: 12px;
        line-height: 20px;
      }
      .content-coord{
        font-family: "OpenSans-Regular";
        font-weight: 400;
        font-size: 12px;
        line-height: 20px;
        color: #838998;
        cursor: pointer;
      }
    }
  }
  .map-info{
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 24px;
    flex-wrap: wrap;
  }

  .map-subtitle {
    margin: 12px 0px;
  }
  .subtitle-text{
    margin: 0px 8px;
  }
  .map-box{
    position: relative;
  }
  .description-box{
    display: flex;
    flex-direction: column;
    margin: 32px 16px;
  }
  .description{
    margin-top: 16px;
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #565E73;
  }
  .galeria-box{
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
  }
  .title-galeria{
    margin: 32px 0px;
  }
  .markerGoogle {
  &:hover {
    cursor: pointer;
  }

  .pinMarker {
    position: relative;
    width: 40px;
    height: 40px;
    border-radius: 50% 50% 0 50%;
    background: white;
    border: 1px solid white;
    transform: rotate(45deg) !important;
    box-shadow: 0px 3px 5px rgba(9, 30, 66, 0.2);
  }
}
.pinCounter {
  position: absolute;
  font-family: "Open Sans";
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  letter-spacing: -0.006em;
  color: black;
  width: 100%;
  left: 0;
  right: 0;
  top: 8px;
  transform: rotate(-45deg);
}
.markerGoogle-registro{
  z-index: 999;
  &:hover {
    cursor: pointer;
  }

  .pinMarker {
    z-index: 999;
    position: relative;
    width: 40px;
    height: 40px;
    border-radius: 50% 50% 0 50%;
    background: #00B1EB;
    border: 1px solid #00B1EB;
    transform: rotate(45deg) !important;
    box-shadow: 0px 3px 5px rgba(9, 30, 66, 0.2);
  }
}

.coord{
  margin: 0px 4px;
}
.timeline-button{
  background-color: #003063;
  color: white;
  padding: 6px 14px;
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  border-radius: 6px;
  outline: 0;
  border: none;
}

@media screen and (min-width: 1px) and (max-width: 800px) {
  .map-title {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
  }
  .timeline-button{
    margin-top: 15px
  }
  .map-az{
    height: 400px;
  }
  .map-container {
    padding: 18px !important;
  }
}
  </style>
  